import { css, styled } from 'styled-components';

import { ThemeMode } from '@/helpers/enums';

import { device } from '@/styles/helpers';

interface ScTableProps {
  mode: ThemeMode;
  withScroll?: boolean;
  mobile?: boolean;
}

export const ScTable = styled.table<ScTableProps>`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-spacing: 0 4px;
  display: ${({ withScroll }) => (withScroll ? 'block' : 'table')};

  thead {
    width: ${({ withScroll }) => (withScroll ? '100%' : 'auto')};
    display: ${({ withScroll }) => (withScroll ? 'table' : 'table-row-group')};

    tr {
      th {
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        letter-spacing: 0.01em;
        padding: 0px 8px 4px;
      }
    }
  }

  tbody {
    margin-top: -4px;
    width: ${({ withScroll }) => (withScroll ? '100%' : 'auto')};
    display: ${({ withScroll }) => (withScroll ? 'table' : 'table-row-group')};

    tr {
      width: ${({ withScroll }) => (withScroll ? '100%' : 'auto')};

      td {
        background: ${({ theme }) => theme.grayLightColor};
        font-size: 16px;
        line-height: 24px;
        color: ${({ theme }) => theme.whiteColor};
        text-align: center;
        padding: 4px 0;
        margin-bottom: 4px;

        @media (${device.mobileS}) {
          font-size: 14px;
          line-height: 24px;
        }

        &:first-child {
          padding-left: 8px;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }
        &:last-child {
          padding-right: 8px;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
        }
      }

      &.active-row {
        td {
          border-color: ${({ theme }) => theme.whiteColor};
          border-style: solid;
          border-width: 1px 0 1px 0;
          padding: 3px 0;

          &:first-child {
            border-left-width: 1px;
            padding-left: 7px;
          }

          &:last-child {
            border-right-width: 1px;
            padding-right: 7px;
          }
        }
      }
    }
  }

  ${({ mode }) =>
    mode === ThemeMode.Light &&
    css`
      thead {
        tr {
          th {
            color: ${({ theme }) => theme.blackColor};
          }
        }
      }
      tbody {
        tr {
          td {
            background: ${({ theme }) => theme.gray1Color};
            color: ${({ theme }) => theme.blackColor};
          }

          &.active-row {
            td {
              border-color: ${({ theme }) => theme.blackColor};
            }
          }
        }
      }
    `}

  .button-show-more {
    display: block;
    text-align: center;
    font-size: 16px;
    line-height: 1.3;
    color: ${({ theme }) => theme.whiteColor};
    padding: 6px 8px;
    width: 100%;
    background-color: ${({ theme }) => theme.mainColor};
    border: none;
    border-radius: 3px;
    cursor: pointer;
  }

  ${({ mobile }) =>
    mobile != null &&
    css`
      @media (${device.mobile}) {
        thead {
          display: none;
          & * {
            display: none;
          }
        }
        tbody {
          & * {
            display: block;
          }
          tr {
            margin-bottom: 16px;
            &:nth-child(2n) {
              td {
                background: rgba(255, 255, 255, 0.2);
              }
            }
          }
          td {
            position: relative;
            display: flex;
            justify-content: space-between;
            text-align: left;
            border-radius: 4px;
            font-size: 13px !important;
            padding-left: 50% !important;
            &:before {
              position: absolute;
              left: 16px;
              content: attr(data-head);
              font-size: 13px;
              top: 50%;
              transform: translateY(-50%);
              color: #fff;
              font-weight: 700;
              letter-spacing: 0.03em;
              text-transform: capitalize;
              opacity: 0.8;
            }
          }
        }
      }
    `}
`;
